import $ from 'jquery'
import { MessageOverlay } from './message-overlay'

const Checkout = {
  HOOK_FORM: '.js-stripe-form',
  HOOK_SUMMARY_TABLE_CONTAINER: '.js-checkout-summary',
  HOOK_CHECKOUT_BUTTON: '.js-checkout-submit',
  LOADING_CLASSES: 'u-is-loading u-is-loading--small-blue',

  init: function () {
    $(document).on('CouponValidation', Checkout.updateSummary)

    $('.js-autofocus').on('click', function () {
      const autofocusSelector = this.dataset.autofocus

      setTimeout(() => {
        const input = document.querySelector(autofocusSelector)
        // Check if the input is visible before focusing
        if (input && input.offsetWidth > 0 && input.offsetHeight > 0) {
          input.focus()
        }
      }, 100)
    })
  },

  /**
   * Update the checkout summary with the provided coupon code.
   * @param {CustomEvent} event The coupon validation event.
   */
  updateSummary: function (event) {
    Checkout.showLoadingState()

    const previewUrl = $(Checkout.HOOK_FORM).data('preview-url')

    // Fetch updated summary table.
    $.ajax({
      method: 'GET',
      url: previewUrl,
      data: {
        coupon_code: event.detail.code,
      },
    })
      .done(function (data) {
        // Updated the summary table.
        $(Checkout.HOOK_SUMMARY_TABLE_CONTAINER).html(data)

        Checkout.hideLoadingState()
      })
      .fail(function () {
        Checkout.hideLoadingState()
        MessageOverlay.show(
          'There was an issue updating the checkout summary. Please check the promotional code and try again.',
          'error'
        )
      })
  },

  /**
   * Show a loading spinner on the checkout summary.
   */
  showLoadingState: function () {
    // Show loading state on summary table.
    $(Checkout.HOOK_SUMMARY_TABLE_CONTAINER).addClass(Checkout.LOADING_CLASSES)

    // Disable state on checkout button.
    $(Checkout.HOOK_CHECKOUT_BUTTON).attr('disabled', true)
  },

  /**
   * Remove the loading spinner from the checkout summary.
   */
  hideLoadingState: function () {
    // Remove loading state from summary table.
    $(Checkout.HOOK_SUMMARY_TABLE_CONTAINER).removeClass(
      Checkout.LOADING_CLASSES
    )

    // Enable checkout button.
    $(Checkout.HOOK_CHECKOUT_BUTTON).removeAttr('disabled')
  },
}

$(Checkout.init)
